import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { API_URL } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import localeCL from '@angular/common/locales/es-CL';
registerLocaleData(localeCL, 'es-CL');
import { createUploadLink } from 'apollo-upload-client';
import { StorageVariable } from './shared/object/local-storage-variable.enum';
const ɵ0 = {
    dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mie', th: 'Jue', fr: 'Vie', sa: 'Sab' },
    dayLabelsFull: { su: 'Domingo', mo: 'Lunes', tu: 'Martes', we: 'Miércoles', th: 'Jueves', fr: 'Viernes', sa: 'Sábado' },
    //monthLabels: { 1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic' },
    //monthLabelsFull: { 1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio', 7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre' },
    dateFormat: 'yyyy-mm-dd',
    todayBtnTxt: 'Hoy',
    clearBtnTxt: 'Limpiar',
    closeBtnTxt: 'Cerrar',
    ariaLabelPrevMonth: 'Mes anterior',
    ariaLabelNextMonth: 'Mes siguiente',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    closeAfterSelect: true,
    alignSelectorRight: true,
    markCurrentDay: true,
    width: '180px',
};
export class AppModule {
    constructor(apollo, httpLink) {
        //const http = httpLink.create({uri: API_URL});
        const http = createUploadLink({ uri: API_URL, });
        const auth = setContext((_, { headers }) => {
            const token = sessionStorage.getItem(StorageVariable.ACCESS_TOKEN_KEY);
            if (!token) {
                return {};
            }
            else {
                return {
                    headers: { 'Authorization': token }
                };
            }
        });
        apollo.create({
            link: auth.concat(http),
            cache: new InMemoryCache(),
        });
    }
}
export { ɵ0 };
